import type { Texture } from 'pixi.js'
import { multiplierTexture } from '../assets/MultiplierTextures'
import { symbolTexture } from '../assets/SymbolTextures'
import { uiTexture } from '../assets/UiTextures'
import { getAvailableMultiplierValues, MULTIPLIER_WHEEL_VALUE, SYMBOL_NAMES } from '../constants'

// 轉輪內容提供者 — 決定某 id 的貼圖與隨機 id。
// 符號轉輪用符號 id；倍數轉輪用倍數值。
export interface ReelStrip {
  randomId(): number
  texture(id: number): Texture | null
}

export const symbolStrip: ReelStrip = {
  randomId: () => Math.floor(Math.random() * SYMBOL_NAMES.length),
  texture: (id) => symbolTexture(id),
}

/**
 * 倍數轉輪（第四輪）內容提供者 — 旋轉中隨機帶入的倍數幣集合隨 ExtraBet 切換：
 * 一般模式 [1,2,3,5,10]、ExtraBet [2,3,5,10,15]（X1↔X15 對調）。對應 Unity
 * Slot001_MultiplierReel.GetCreateSymbolIndex 依 PlayerBetData.IsExtraBet 過濾。
 * 注入 `isExtraBet` 取值函式而非固定狀態，避免可變全域（沿用來源反模式）。
 * Wheel(0) 不隨機出現，只在伺服器判定停在 Wheel 時做為結果帶入。
 */
export function createMultiplierStrip(isExtraBet: () => boolean): ReelStrip {
  return {
    randomId: () => {
      const values = getAvailableMultiplierValues(isExtraBet())
      // values 保證非空（getAvailableMultiplierValues 不變式），索引必落在範圍內。
      return values[Math.floor(Math.random() * values.length)]!
    },
    // Wheel 符號（值 0）沿用左側 Bonus 立輪的轉盤圖；其餘為對應倍數幣。
    texture: (value) =>
      value === MULTIPLIER_WHEEL_VALUE ? uiTexture('wheel_disc') : multiplierTexture(value),
  }
}
